import { mergeRefs } from '@grupoboticario/flora-react-utils';
import { useRef, useState, useEffect } from 'react';
import { numberMask, patternMask } from './utils';

var getMaskedValue = (value, mask) => {
  if (typeof mask === 'string') {
    return patternMask(value, mask);
  } else if (typeof mask === 'function') {
    return mask(value);
  } else if (typeof mask === 'object') {
    return numberMask(value, mask);
  }

  return value;
};

export function useMask(props) {
  var {
    mask,
    ref,
    value,
    defaultValue,
    onChange,
    onKeyDown
  } = props;
  var inputRef = useRef(null);
  var [defaultValueMasked, setDefaultValueMasked] = useState('');
  useEffect(() => {
    if (!!mask) {
      setDefaultValueMasked(getMaskedValue(value || defaultValue || '', mask));
    }
  }, [mask, value, defaultValue]);

  var handleChange = e => {
    if (mask) {
      var _inputRef$current;

      var newValue = getMaskedValue((_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value, mask) || '';
      inputRef.current.value = newValue;
      e.target.value = newValue;
      setDefaultValueMasked(newValue);
    }

    if (onChange) onChange(e);
  };

  var handleKeyPress = e => {
    var _e$key;

    var isKeyDelete = ((_e$key = e.key) == null ? void 0 : _e$key.toLowerCase()) === 'backspace' || e.keyCode === 8;

    if (isKeyDelete && typeof mask === 'object' && mask.style === 'percent') {
      var _inputRef$current2, _inputRef$current3;

      var _value = (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.value;

      var newValue = _value.replace('%', '');

      if (((_inputRef$current3 = inputRef.current) == null ? void 0 : _inputRef$current3.selectionStart) !== newValue.length) {
        // delete only if cursor is at the end
        ;
        inputRef.current.value = newValue.slice(0, newValue.length);
      }
    }

    if (onKeyDown) onKeyDown(e);
  };

  return {
    value: defaultValueMasked || value,
    defaultValue: defaultValueMasked || defaultValue,
    onChange: handleChange,
    onKeyDown: handleKeyPress,
    ref: mergeRefs(ref, inputRef)
  };
}
//# sourceMappingURL=useMask.js.map